import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserDetails {
  [key: string]: any;
}

interface UserState {
  userDetails: UserDetails;
}

const initialState: UserState = {
  userDetails: {}
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserDetails(state, action: PayloadAction<UserDetails>) {
      state.userDetails = action.payload;
    },
    clearUserDetails: (state) => {
      state.userDetails = {}; // Reset user details
    }
  }
});

export const { setUserDetails, clearUserDetails } = userSlice.actions;
export default userSlice.reducer;
